var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { GlobalPatientReference, PatientGuidedConsentDto } from "./patient.dtos";
import { IsBoolean, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from "class-validator";
import { ConsentFlowProgressDto, ConsentStateSearchInput } from "./consent.dtos";
import { IdentifiedPatientDto } from "./recruitment.dtos";
import { StudyDto } from "./study.dtos";
import { PatientConsentsByStudyDto } from "./patient.consent.dtos";
import { ConsentRequestSearchInput } from "./consent.request.dtos";
export class BasicSearchTermInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], BasicSearchTermInput.prototype, "equalsOneOf", void 0);
export class LocationAndDistance {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], LocationAndDistance.prototype, "location", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], LocationAndDistance.prototype, "withinDistance", void 0);
export class LocationSearchTermInput extends BasicSearchTermInput {
}
__decorate([
    Type(() => LocationAndDistance),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", Object)
], LocationSearchTermInput.prototype, "near", void 0);
export class ComparableSearchTermInput extends BasicSearchTermInput {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ComparableSearchTermInput.prototype, "lessThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ComparableSearchTermInput.prototype, "greaterThanOrEqual", void 0);
export class ConditionSearchTermInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ConditionSearchTermInput.prototype, "equalsOneOf", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ConditionSearchTermInput.prototype, "childrenOf", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ConditionSearchTermInput.prototype, "excludeChildrenOf", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ConditionSearchTermInput.prototype, "withinWeeks", void 0);
export class MedicationSearchTermInput {
}
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], MedicationSearchTermInput.prototype, "medicationCodeEquals", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", String)
], MedicationSearchTermInput.prototype, "withinWeeks", void 0);
export class ObservationSearchTermInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ObservationSearchTermInput.prototype, "obEquals", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], ObservationSearchTermInput.prototype, "valueEqualsOneOf", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ObservationSearchTermInput.prototype, "valueLessThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ObservationSearchTermInput.prototype, "valueGreaterThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ObservationSearchTermInput.prototype, "unit", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], ObservationSearchTermInput.prototype, "withinWeeks", void 0);
export class BaseSearchCriteria {
}
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", BasicSearchTermInput)
], BaseSearchCriteria.prototype, "gender", void 0);
__decorate([
    Type(() => ComparableSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ComparableSearchTermInput)
], BaseSearchCriteria.prototype, "age", void 0);
__decorate([
    Type(() => LocationSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", LocationSearchTermInput)
], BaseSearchCriteria.prototype, "zip", void 0);
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", BasicSearchTermInput)
], BaseSearchCriteria.prototype, "race", void 0);
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", BasicSearchTermInput)
], BaseSearchCriteria.prototype, "ethnicity", void 0);
__decorate([
    Type(() => ConditionSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ConditionSearchTermInput)
], BaseSearchCriteria.prototype, "condition", void 0);
__decorate([
    Type(() => ObservationSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ObservationSearchTermInput)
], BaseSearchCriteria.prototype, "lab", void 0);
__decorate([
    Type(() => ObservationSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ObservationSearchTermInput)
], BaseSearchCriteria.prototype, "vital", void 0);
__decorate([
    Type(() => MedicationSearchTermInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", MedicationSearchTermInput)
], BaseSearchCriteria.prototype, "medication", void 0);
export class ClassicSearchInput extends BaseSearchCriteria {
}
export class SearchCriteria extends BaseSearchCriteria {
}
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SearchCriteria.prototype, "nestedCriteria", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], SearchCriteria.prototype, "negate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SearchCriteria.prototype, "operator", void 0);
export class SearchInput {
}
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], SearchInput.prototype, "mrns", void 0);
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], SearchInput.prototype, "criteria", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], SearchInput.prototype, "limit", void 0);
__decorate([
    Type(() => ConsentStateSearchInput),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SearchInput.prototype, "consentState", void 0);
export class SearchByMRNInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], SearchByMRNInput.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SearchByMRNInput.prototype, "studyId", void 0);
__decorate([
    Type(() => ConsentRequestSearchInput),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ConsentRequestSearchInput)
], SearchByMRNInput.prototype, "consentRequestSearchInput", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], SearchByMRNInput.prototype, "start", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], SearchByMRNInput.prototype, "end", void 0);
export class SearchByMRNInputWithoutConsents {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], SearchByMRNInputWithoutConsents.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SearchByMRNInputWithoutConsents.prototype, "projectId", void 0);
export class SearchByPatientHealthExIdInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], SearchByPatientHealthExIdInput.prototype, "patientHealthExId", void 0);
export class RelatedMedicationSearchInput {
}
__decorate([
    IsString({ each: true }),
    __metadata("design:type", Array)
], RelatedMedicationSearchInput.prototype, "medicationCodes", void 0);
export class AgentSearchInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], AgentSearchInput.prototype, "mrns", void 0);
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Object)
], AgentSearchInput.prototype, "criteria", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], AgentSearchInput.prototype, "limit", void 0);
__decorate([
    Type(() => ConsentStateSearchInput),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], AgentSearchInput.prototype, "consentState", void 0);
export class SearchResultsSummary {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "gender", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "age", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "zip", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "race", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "ethnicity", void 0);
__decorate([
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], SearchResultsSummary.prototype, "conditions", void 0);
export class SearchResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => GlobalPatientReference),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], SearchResults.prototype, "matches", void 0);
__decorate([
    Type(() => SearchResultsSummary),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", SearchResultsSummary)
], SearchResults.prototype, "summary", void 0);
export class SearchByMRNPatientResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => PatientGuidedConsentDto),
    IsOptional(),
    ValidateNested(),
    __metadata("design:type", Object)
], SearchByMRNPatientResults.prototype, "patient", void 0);
__decorate([
    Type(() => PatientConsentsByStudyDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], SearchByMRNPatientResults.prototype, "consents", void 0);
export class SearchByMRNPatientResultsWithoutConsents {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SearchByMRNPatientResultsWithoutConsents.prototype, "totalProcessed", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SearchByMRNPatientResultsWithoutConsents.prototype, "successCount", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SearchByMRNPatientResultsWithoutConsents.prototype, "errorCount", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], SearchByMRNPatientResultsWithoutConsents.prototype, "duplicatesCount", void 0);
__decorate([
    IsOptional(),
    Type(() => Object),
    __metadata("design:type", Array)
], SearchByMRNPatientResultsWithoutConsents.prototype, "errors", void 0);
__decorate([
    IsOptional(),
    Type(() => Object),
    __metadata("design:type", Array)
], SearchByMRNPatientResultsWithoutConsents.prototype, "duplicates", void 0);
__decorate([
    IsOptional(),
    Type(() => Object),
    __metadata("design:type", Array)
], SearchByMRNPatientResultsWithoutConsents.prototype, "successfulPatients", void 0);
export class SearchByMRNIdentifiedPatientResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => StudyDto),
    IsOptional(),
    ValidateNested(),
    __metadata("design:type", Object)
], SearchByMRNIdentifiedPatientResults.prototype, "study", void 0);
__decorate([
    Type(() => PatientGuidedConsentDto),
    IsOptional(),
    ValidateNested(),
    __metadata("design:type", Object)
], SearchByMRNIdentifiedPatientResults.prototype, "patient", void 0);
__decorate([
    Type(() => IdentifiedPatientDto),
    IsOptional(),
    __metadata("design:type", Object)
], SearchByMRNIdentifiedPatientResults.prototype, "identifiedPatient", void 0);
__decorate([
    Type(() => ConsentFlowProgressDto),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], SearchByMRNIdentifiedPatientResults.prototype, "consentFlowProgress", void 0);
export class AgentSearchResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => SearchResultsSummary),
    __metadata("design:type", SearchResultsSummary)
], AgentSearchResults.prototype, "summary", void 0);
export class AgentSearchByMRNResult {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], AgentSearchByMRNResult.prototype, "healthExPatientId", void 0);
export class AgentSearchResultsSummary {
}
